module.exports = __webpack_public_path__ + "Public/Home/staticmokao/img/sanjiao-left.5b08d15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/sanjiao-left.png
// module id = aD57
// module chunks = 1